// App-side delegate for `@heidi/commerce/data`.
// Resolves `hasUser` and Clinician Max beta for the package hook.
import { GET_CREDIT_ALLOWANCE } from '@heidi/commerce/contracts';
import {
  getCurrentCreditAllowance,
  invalidateCreditAllowance as invalidateCreditAllowanceCore,
  useQueryCreditAllowance as useQueryCreditAllowanceCore,
} from '@heidi/commerce/data';

import { useIsHeidi2ClinicianMaxBetaEnabled } from '@/features/flags';
import { useQueryUser } from '@heidi/workspace/data';

export { GET_CREDIT_ALLOWANCE, getCurrentCreditAllowance };

export function useQueryCreditAllowance(enabled = true) {
  const { data: user } = useQueryUser();
  const isClinicianMaxBetaEnabled = useIsHeidi2ClinicianMaxBetaEnabled();

  return useQueryCreditAllowanceCore({
    hasUser: !!user,
    enabled,
    pollWhileUnprovisioned: isClinicianMaxBetaEnabled,
  });
}

export const invalidateCreditAllowance = () => invalidateCreditAllowanceCore();
